import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import * as React from "react";
import * as CopyToClipboard from "react-copy-to-clipboard";
// import CustomModal from "./CustomModal";
import { withRouter, RouteComponentProps } from "react-router-dom";
import CancelModal from "./CancelModal";

const styles = (theme: Theme) => ({
  button: {
    width: "30%",
  },
  text: {
    width: "60%",
  },
});

interface ICopyButtonProps {
  link: string;
  disableParent: boolean;
}

interface ICopyButtonState {
  copied: boolean;
  showParentAddon: boolean;
}

type IProps = ICopyButtonProps &
  WithStyles<keyof ReturnType<typeof styles>> &
  RouteComponentProps & { isStarterPlan: boolean; route: any };

export default withRouter(
  withStyles(styles)(
    class extends React.Component<IProps, ICopyButtonState> {
      constructor(props: IProps) {
        super(props);
        this.state = {
          copied: false,
          showParentAddon: false,
        };
      }

      public handleCopy = (e: any) => {
        e.preventDefault(); // Disable text copying
      };

      public render() {
        const { classes, link } = this.props;
        const upgradeRoute =
          typeof this.props.route === "string"
            ? this.props.route.replace("/upgrade-subscription", "/subscription-history")
            : this.props.route;
        return (
          <>
            <Grid container={true} spacing={2} justifyContent="space-around">
              {this.props.disableParent ? (
                <TextField
                  inputProps={{ readOnly: true }}
                  value={link}
                  className={classes.text}
                  InputProps={{
                    style: {
                      filter: this.props.disableParent ? "blur(5px)" : "none",
                    },
                  }}
                  onCopy={this.handleCopy}
                />
              ) : (
                <TextField
                  inputProps={{ readOnly: true }}
                  value={link}
                  className={classes.text}
                />
              )}
              <CopyToClipboard text={link}>
                <Button
                  className={classes.button}
                  style={this.getButtonStyle()}
                  onClick={this.renderButton}
                  variant="contained"
                  color="primary"
                >
                  {this.state.copied ? "Copied!" : "Copy"}
                </Button>
              </CopyToClipboard>
            </Grid>

            <CancelModal
              open={this.state.showParentAddon}
              handleOk={() => {
                this.props.history.push(upgradeRoute);
              }}
              handleClose={() => {
                this.setState({ showParentAddon: false });
              }}
              positiveText={"Upgrade Subscription "}
              title={"Parent Survey"}
              description={"If you would like to add parent surveys, please upgrade your subscription or add on parent surveys to your current subscription."}
            />
          </>
        );
      }

      private renderButton = () => {
        if (this.props?.disableParent) {
          this.setState({ showParentAddon: true });
        } else {
          this.setState({ copied: true });
          setTimeout(() => {
            this.setState({ copied: false });
          }, 1000);
        }
      };

      private getButtonStyle = () => {
        if (this.state.copied) {
          return {
            backgroundColor: "#D9FED4",
            color: "#2A8A21",
          };
        } else {
          return {};
        }
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/shared/components/CopyButton.tsx